/* 
合同主体展示
*/
import ZContract from './contract'
export default ZContract